import React from 'react';
import type ServicedeskQueuesEditViewType from '@atlassian/jira-spa-apps-servicedesk-queues-edit-view/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

/**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */
export const LazyServicedeskQueuesEditView = lazyForPaint<typeof ServicedeskQueuesEditViewType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-queues-edit-view", jiraSpaEntry: "async-servicedesk-queues-edit-view" */ '@atlassian/jira-spa-apps-servicedesk-queues-edit-view'
			),
		),
);

type Props = RouteContext;

/**
 * @deprecated Remove this when fsm_views_inside_queues_-_main_flag is cleaned up
 */

const AsyncServicedeskQueuesEditView = ({ match }: Props): React.JSX.Element => {
	const queueId = (match.params && match.params.queueId) || '';

	return (
		<LazyPage
			Page={LazyServicedeskQueuesEditView}
			pageId={`spa-apps/servicedesk/queues/edit/${queueId}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskQueuesEditView;
